module.exports = __webpack_public_path__ + "img/music-work-icon15.135578b4.png";